import React from 'react';
import { ADMIN_BASE_PATH } from '../../admin/adminConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const AdminHeader = ({ title, subtitle, showBackButton = true, children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    // If we're on a sub-page, go back to dashboard
    if (location.pathname !== ADMIN_BASE_PATH && location.pathname !== `${ADMIN_BASE_PATH}/dashboard`) {
      navigate(`${ADMIN_BASE_PATH}/dashboard`);
    } else {
      // If we're on dashboard, go to main site
      navigate('/');
    }
  };

  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6">
          <div className="flex items-center">
            {showBackButton && (
              <button
                onClick={handleBack}
                className="mr-4 p-2 text-gray-400 hover:text-gray-600 transition-colors"
                title="უკან"
              >
                <ArrowLeftIcon className="h-6 w-6" />
              </button>
            )}
            <img 
              src="https://cup.gff.ge/sites/default/files/styles/logo_medium/public/2024-12/iveria.png?itok=FR6w_kKm" 
              alt="FC Iveria Logo" 
              className="w-10 h-10 rounded-full object-cover"
            />
            <div className="ml-3">
              <h1 className="text-2xl font-bold text-gray-900 font-georgian">
                {title || 'ადმინისტრაციული პანელი'}
              </h1>
              <p className="text-sm text-gray-600 font-georgian">
                {subtitle || 'FC ივერია'}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            {children}
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;

